<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>Tijdlijn</mat-card-title>
    <mat-card-subtitle>Alles op een rijtje</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content class="overflow-auto">
    <table class="mat-mdc-table mt-3">
      <thead>
      <tr>
        <th style="width: 200px;"></th>
        <th></th>
        <th style="width: 200px;" class="text-right">
          <button mat-icon-button matTooltip="Refresh"
                  (click)="getData()">
            <mat-icon>refresh</mat-icon>
          </button>
          <button (click)="openTimelineEditor(null ,{Model: Model, ParentId: ParentId})" mat-icon-button>
            <mat-icon>add</mat-icon>
          </button>
        </th>
      </tr>
      </thead>
      <tr *ngIf="filterObject.loading">
        <td colspan="3">
          <div class="row text-center mt-4 mb-4">
            <div class="col-2 offset-5">
              <mat-spinner class="m-auto"></mat-spinner>
            </div>
          </div>
        </td>
      </tr>
      <tr *ngFor="let row of List">
        <td class="text-left"><mat-icon matListItemIcon>{{row.Type?.FreeTextField1 || 'note'}}</mat-icon></td>
        <td class="text-left"><strong>{{row.Start | date: 'short'}} - {{row.Type?.Value}}</strong><br/>{{limitText(row.Description)}}</td>
        <td style="width: 150px;" class="text-right">
          <button (click)="openTimelineEditor(row)" mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button>
          <button (confirm)="_Timeline.removeTimeline(row, List)" appConfirmDialog mat-icon-button>
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <mat-paginator
            [length]="filterObject.count"
            [pageSizeOptions]="[5, 10, 25, 100]"
            [pageSize]="filterObject.limit"
            (page)="pageChange($event)">
          </mat-paginator>
        </td>
      </tr>
    </table>
  </mat-card-content>
</mat-card>
